import React from "react";
import { Breadcrumb } from "antd";
import { useState } from "react";
import EnquiryTabs from "./enquiryTabs";

const Enquiry = () => {
  const [breadcrumb,setBreadcrumb] = useState("Contact")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Enquiry</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Enquiry" }, { title: breadcrumb }]}
        />
      </div>
      <EnquiryTabs setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default Enquiry;
